<template>
  <div>
    <v-text-field type="email" hint="Email" placeholder="Email" v-model="emailAuthModel.email"></v-text-field>
    <v-text-field type="password" hint="Password" placeholder="Password" v-model="emailAuthModel.password"></v-text-field>
    <v-text-field type="password" hint="Confirm password" placeholder="Confirm password" v-model="emailAuthModel.confirmPassword" v-if="signupMode"></v-text-field>
    <v-container grid-list-md text-xs-center>
      <v-layout row wrap>
        <v-flex xs12>
          <v-btn color="accent" v-if="signupMode" @click="authWithEmail" block>Sign up</v-btn>
        </v-flex>
        <v-flex xs6>
          <v-btn color="accent" v-if="!signupMode" @click="signupMode = true" block>Sign up</v-btn>
        </v-flex>
        <v-flex xs6>
          <v-btn color="primary" v-if="!signupMode" @click="loginWithEmail" block>Login</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-footer app style="height: 100px;">
      <img src="../assets/google_signin.png" @click.prevent="loginWithGoogle" style="width: 200px; margin: 0 auto; display: block; cursor: pointer;">
    </v-footer>
  </div>
</template>

<script>
import { firestore } from '../firestoreConnection';
import firebase from 'firebase/app';
import 'firebase/auth';

export default {
  name: 'simple-login',
  data() {
    return {
      signupMode: false,
      emailAuthModel: {
        email: '',
        password: '',
        confirmPassword: ''
      }
    };
  },
  mounted() {
    firebase.auth().onAuthStateChanged(
      function(user) {
        if (user) {
          return this.$router.push('/');
        }
      }.bind(this)
    );

    // firebase
    //   .auth()
    //   .getRedirectResult()
    //   .then(
    //     function(result) {
    //       if (result.user) {
    //         var user = result.user;

    //         this.$store.state.user.uid = user.uid;
    //         this.$store.state.user.displayName = user.displayName;
    //         this.$store.state.user.photoURL = user.photoURL;
    //         this.$store.state.user.email = user.email;

    //         firestore.doc(`users/${user.uid}`).set({
    //           displayName: user.displayName,
    //           photoURL: user.photoURL,
    //           email: user.email
    //         });
    //         this.$router.push('/');
    //       }
    //     }.bind(this)
    //   )
    //   .catch(function(error) {
    //     console.error('RDR: ' + error);
    //   });
  },
  methods: {
    loginWithGoogle: function() {
      var provider = new firebase.auth.GoogleAuthProvider();
      // firebase.auth().signInWithRedirect(provider);

      firebase
        .auth()
        .signInWithPopup(provider)
        .then(
          function(result) {
            var user = result.user;

            this.$store.state.user.uid = user.uid;
            this.$store.state.user.displayName = user.displayName;
            this.$store.state.user.photoURL = user.photoURL;
            this.$store.state.user.email = user.email;

            firestore.doc(`users/${user.uid}`).set({
              displayName: user.displayName,
              photoURL: user.photoURL,
              email: user.email
            });
            this.$router.push('/');
          }.bind(this)
        );
    },
    authWithEmail: function() {
      if (this.emailAuthModel.password === this.emailAuthModel.confirmPassword && this.emailAuthModel.password !== '') {
        firebase
          .auth()
          .createUserWithEmailAndPassword(this.emailAuthModel.email, this.emailAuthModel.password)
          .then(
            function(result) {
              if (result.user) {
                var user = result.user;

                this.$store.state.user.uid = user.uid;
                this.$store.state.user.email = user.email;
                if (user.displayName) {
                  this.$store.state.user.displayName = user.displayName;
                } else {
                  this.$store.state.user.displayName = user.email;
                }
                if (user.photoURL) {
                  this.$store.state.user.photoURL = user.photoURL;
                } else {
                  this.$store.state.user.photoURL = '/static/img/header.jpg';
                }

                firestore.doc(`users/${user.uid}`).set({
                  displayName: this.$store.state.user.displayName,
                  photoURL: this.$store.state.user.photoURL,
                  email: this.$store.state.user.email
                });
                this.$router.push('/');
              }
            }.bind(this)
          )
          .catch(function(error) {
            alert(error.message);
          });
      } else {
        alert('Passwords do not match');
      }
    },
    loginWithEmail: function() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.emailAuthModel.email, this.emailAuthModel.password)
        .then(
          function(result) {
            if (result.user) {
              var user = result.user;

              this.$store.state.user.uid = user.uid;
              this.$store.state.user.email = user.email;
              if (user.displayName) {
                this.$store.state.user.displayName = user.displayName;
              } else {
                this.$store.state.user.displayName = user.email;
              }
              if (user.photoURL) {
                this.$store.state.user.photoURL = user.photoURL;
              } else {
                this.$store.state.user.photoURL = '/static/img/header.jpg';
              }

              firestore.doc(`users/${user.uid}`).set({
                displayName: this.$store.state.user.displayName,
                photoURL: this.$store.state.user.photoURL,
                email: this.$store.state.user.email
              });
              this.$router.push('/');
            }
          }.bind(this)
        );
    }
  }
};
</script>

<style scoped>
</style>
